import React, {memo} from 'react';

import {FormInput} from '@homeaway/react-form-components';

// FormInput.whyDidYouRender = true;

import {useComponent} from './hooks/useComponent';

import './SearchDestinationSummaryInputField.less';

const SearchDestinationSummaryInputField = memo(function SearchDestinationSummaryInputField() {
    const {
        className,
        id,
        inputClassName,
        type,
        label,
        srOnlyLabel,
        value,
        readOnly,
        isReadOnly,
        inverse,
        leftContent,
        rightContent,
        contentClickable,
        errorMsg,
        helpText,
        autoComplete,
        autoCapitalize,
        autoCorrect,
        spellCheck,
        ariaAutoComplete,
        onChange,
        onClick,
        onKeyPress
    } = useComponent();

    return (
        <div className={className}>
            <FormInput
                id={id}
                inputClassName={inputClassName}
                type={type}
                label={label}
                srOnlyLabel={srOnlyLabel}
                value={value}
                readOnly={readOnly}
                isReadOnly={isReadOnly}
                inverse={inverse}
                leftContent={leftContent}
                rightContent={rightContent}
                contentClickable={contentClickable}
                errorMsg={errorMsg}
                helpText={helpText}
                autoComplete={autoComplete}
                autoCapitalize={autoCapitalize}
                autoCorrect={autoCorrect}
                spellCheck={spellCheck}
                aria-autocomplete={ariaAutoComplete}
                onChange={onChange}
                onClick={onClick}
                onKeyPress={onKeyPress}
            />
        </div>
    );
});

SearchDestinationSummaryInputField.whyDidYouRender = true;

export {SearchDestinationSummaryInputField};
